module.exports = __webpack_public_path__ + "img/1alB-r-ret.c1c81710.jpg";